import { MsgValidation } from "c4u-web-components";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { IDealershipRegisterForm } from "../../../models";

export const RegisterDealershipValidation = () => {
  const { t } = useTranslation();

  const msgRequired = t(MsgValidation.RequiredField);

  const validations = Yup.object<IDealershipRegisterForm>({
    phone: Yup.string().required(msgRequired),
  });

  return validations;
};
